<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <div
          id="home"
          class="container-fluid menu-margin-top"
          style="padding-left:0px;padding-right:0px"
        >
          <div v-if="checkAccess('home')">
            <div class="row row-cols-lg-5 row-cols-md-5 row-cols-sm-2 p-2">
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <span>
                  <b>View Schedules of Employee</b>
                </span>
              </div>
              <!--col end-->
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <div v-if="this.showdropdown">
                  <select
                    v-model.trim="selectedEmpId"
                    class="form-control input-sm"
                    id="myInput"
                    @change="getScheduleActForSelectedEmp"
                  >
                    <option value="All" key="All">All</option>
                    <option
                      v-for="(option, index) in employeeList"
                      :value="option.employeeId"
                      :key="index"
                      >{{ option.firstName }}
                      {{
                        option.middleName.length != 0
                          ? "," + option.middleName
                          : ""
                      }}
                      , {{ option.lastName }}</option
                    >
                  </select>
                </div>
              </div>
              <!--col end-->
            </div>
            <!--row end-->
            <div class="row p-2 justify-content-center mb-5">
              <div class="col">
                <div
                  class="table-responsive table-responsive-sm mb-5"
                  style="height:250px;overflow:auto;"
                >
                  <v-table
                    id="activitiesTable"
                    :data="listactivities"
                    :currentPage.sync="currentPage"
                    :pageSize="5"
                    @totalPagesChanged="totalPages = $event"
                    class="table table-sm table-bordered table-striped"
                  >
                    <thead
                      class="table-month-header-blue wrap-text"
                      slot="head"
                    >
                      <v-th sortKey="creationD">Created Date</v-th>
                      <v-th sortKey="scheduleD">Schedule Date</v-th>
                      <v-th sortKey="employee.firstName">Name</v-th>
                      <v-th sortKey="employee.duserRole.userRoleX">Role</v-th>
                      <v-th sortKey="scheduleNotes">Last Updated Notes</v-th>
                    </thead>
                    <tbody slot="body" slot-scope="{ displayData }">
                      <tr
                        v-for="activity in displayData"
                        id="score-view-table-data"
                      >
                        <td>{{ activity.creationD | moment("MM/DD/YYYY") }}</td>
                        <td>{{ activity.scheduleD | moment("MM/DD/YYYY") }}</td>
                        <td>
                          {{ activity.employee.firstName }} ,
                          {{ activity.employee.lastName }}
                        </td>
                        <td>{{ activity.employee.duserRole.userRoleX }}</td>
                        <td>{{ activity.scheduleNotes }}</td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
              <!--col end-->
            </div>
            <!--row end-->
          </div>
        </div>
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import schedulesjson from '../json/schedules.json'
import httpemployee from '../js/http-employee.js'
import httpactivity from '../js/http-activitytracking'
import messagesjson from '../json/messages.json'
import userjson from '../json/scheduleusers.json'
import { hasAccess } from '../js - Local/permissions.js'
export default {
  name: 'home',
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/')
    }
  },
  created () {},
  data () {
    return {
      userType: this.$session.get('user_role'),
      employeeList: [],
      names: userjson,
      listactivities: [],
      currentPage: 1,
      totalPages: 0,
      listMessages: messagesjson,
      selectedEmpId: 'All',
      showdropdown: this.$session.get('user_role') != 'SR',
      targetUser: 'Admin Agent',
      heads: [
        { name: 'Created Date' },
        { name: 'Schedule Date' },
        { name: 'Name' },
        { name: 'Role' },
        { name: 'Last Updated Notes' }
      ],
      header: [
        { name: 'Created Date' },
        { name: 'Name ' },
        { name: 'Messages' },
        { name: 'Role' },
        { name: 'Action' }
      ]
    }
  },
  methods: {
    logout: function () {
      this.$session.clear()
      this.$session.destroy()
      this.$router.push('/')
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#home').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },

    fetchData () {
      this.retrieveEmployeeList()
      this.retrieveScheduledActivities()
    },
    getScheduleActForSelectedEmp: function (event) {
      if (this.selectedEmpId == 'All') {
        this.retrieveScheduledActivitiesForAllEmployee()
      } else {
        this.retrieveScheduledActivitiesForAnEmployee(this.selectedEmpId)
      }
    },
    retrieveScheduledActivitiesForAnEmployee (empId) {
      httpactivity
        .get('schedule/employee/' + empId)
        .then(response => {
          if (response.data.length != 0) {
            this.listactivities = response.data
          } else {
            this.listactivities = []
          }
        })
        .catch(e => {
          this.listactivities = []
        })
    },
    retrieveScheduledActivitiesForAllEmployee () {
      httpactivity
        .get('/schedule/')
        .then(response => {
          if (response.data.length != 0) {
            this.listactivities = response.data
          } else {
            this.listactivities = []
          }
        })
        .catch(e => {
          console.log('Failed to get Schedule activities for employees')
          this.listactivities = []
        })
    },
    retrieveScheduledActivities () {
      // Check if logged in employee is SR
      if (this.userType == 'SR') {
        this.retrieveScheduledActivitiesForAnEmployee(
          this.$session.get('employee_id')
        )
      } else {
        this.retrieveScheduledActivitiesForAllEmployee()
      }
    },
    createSearchObject () {
      return {
        firstName: '',
        lastName: '',
        roleType: '',
        statusCode: 'A'
      }
    },
    retrieveEmployeeList () {
      let searchEmployee = this.createSearchObject()
      httpemployee
        .post('/employee/search/', searchEmployee)
        .then(response => {
          this.employeeList = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    checkAccess (permission) {
        return hasAccess(permission)
    }
  },
  components: {
    TopHeader,
    BottomFooter,
    MainMenu
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.fetchData()
    this.myFunction()
    this.menuheight()
  }
}
</script>
<style scoped></style>
